import { apiClient } from "./auth";
import type {
  OpportunityExportFilters,
  RequestOpportunityExportAllPayload,
  RequestOpportunityExportPayload,
} from "./opportunityExport";
import type {
  GetOverviewExportHistoryResponse,
  GetOverviewExportStatusResponse,
  RequestOverviewExportResponse,
} from "./overviewExportTypes";

export async function requestOverviewOpportunityExportApi(
  payload: RequestOpportunityExportPayload
): Promise<RequestOverviewExportResponse> {
  const res = await apiClient.post<
    RequestOpportunityExportPayload,
    RequestOverviewExportResponse
  >("/opportunities/export", payload);
  return res.data;
}

export async function requestOverviewOpportunityExportAllApi(
  payload: RequestOpportunityExportAllPayload
): Promise<RequestOverviewExportResponse> {
  const res = await apiClient.post<
    RequestOpportunityExportAllPayload,
    RequestOverviewExportResponse
  >("/opportunities/export/export-all", payload);
  return res.data;
}

export async function getOverviewOpportunityExportStatusApi(
  exportId: string
): Promise<GetOverviewExportStatusResponse> {
  const res = await apiClient.get<GetOverviewExportStatusResponse>(
    `/opportunities/export/${encodeURIComponent(exportId)}`
  );
  return res.data;
}

export async function getOverviewOpportunityExportHistoryApi(params?: {
  limit?: number;
  offset?: number;
}): Promise<GetOverviewExportHistoryResponse> {
  const query = new URLSearchParams();
  if (params?.limit != null) query.append("limit", String(params.limit));
  if (params?.offset != null) query.append("offset", String(params.offset));
  const url = query.toString()
    ? `/opportunities/export/history?${query.toString()}`
    : "/opportunities/export/history";
  const res = await apiClient.get<GetOverviewExportHistoryResponse>(url);
  return res.data;
}

export type { OpportunityExportFilters };
